import React from 'react';
import ContactUsFormProps from "./props";
import './contact-us.scss';
import DynamicContactForm from '../../private/DynamicContactForm';

function ContactUsForm(props: ContactUsFormProps) {
  return (
    <DynamicContactForm {...props} cssPrefix="contact-us" />
  )
}

export default React.memo(ContactUsForm);
